var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:(_vm.titleTooltip),expression:"titleTooltip"}],staticClass:"btn-table",attrs:{"id":`edit-btn-${_vm.id}`},on:{"click":function($event){return _vm.$emit('click')}}},[_c('DynamicIcon',{attrs:{"icon":"table-edit","classString":"icon-btn-table"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }